import React, {Fragment} from 'react';
import {useParams} from 'react-router';
import CardContainerForm from '../../components/CardContainerForm';
import Form from '../../components/forms/Holiday';

export default function RegularTables1(props) {
  const {id} = useParams();

  return (
    <>
      <CardContainerForm>
        <Form openAlert={props.openAlert} id={id} />
      </CardContainerForm>
    </>
  );
}
